<div class="showmore-container marginless textalign-right background-{{ backgroundColor }}">
    <div class="button-middle-wrapper" *ngIf="buttonLabelMore && !(showMore$ | async)">
        <button
            da-button
            (click)="onClick()"
            [themeType]="backgroundColor === 'draegerblue' || 'grey' ? 'Secondary' : 'Primary'"
            [innerHTML]="buttonLabel$ | async"
            data-dte-action="showmore.open"
        ></button>
    </div>

    <ng-container *ngIf="showMore$ | async">
        <button
            (click)="onClick()"
            class="button-right reset"
            [ngClass]="{
                'show-less': showMore$ | async,
                'show-mobile': !(hasMiddleButton$ | async) || ((hasMiddleButton$ | async) && (showMore$ | async))
            }"
            [innerHtml]="label$ | async"
            tabindex="0"
        ></button>
    </ng-container>
    <ng-container *ngIf="!(showMore$ | async)">
        <button
            (click)="onClick()"
            class="button-right reset"
            [ngClass]="{
                'show-less': showMore$ | async,
                'show-mobile': !(hasMiddleButton$ | async) || ((hasMiddleButton$ | async) && (showMore$ | async))
            }"
            [innerHtml]="label$ | async"
            tabindex="0"
            data-dte-action="showmore.open"
        ></button>
    </ng-container>
</div>
